<template>
  <div class="login">
    <div class="contents">
      <div class="login-base">
        <login-title :type.sync="showType" />
        <user-login-by-phone v-if="showType == 1" />
        <user-login-by-mail v-if="showType == 2" />
      </div>
    </div>
  </div>
</template>

<script>
import UserLoginByPhone from "../components/user/UserLoginByPhone.vue";
import UserLoginByMail from "../components/user/UserLoginByMail.vue";
import LoginTitle from "../components/user/LoginTitle.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { UserLoginByPhone, LoginTitle, UserLoginByMail },
  data() {
    return {
      showType: 1,
    };
  },
  metaInfo() {
    return {
      title: "欢迎登录Movibot官网",
      meta: [
        { name: "keywords", content: "Movibot官网" },
        { name: "description", content: "欢迎登录Movibot网站" },
      ],
    };
  },
  watch: {
    UserToken(val, oldval) {
      if (val != "") {
        if (window.history.length <= 1) {
          this.$router.push({ name: "userindex" });
        } else {
          this.$router.go(-1);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["UserToken"]),
  },
};
</script>
<style  scoped>
.login {
  position: relative;
  width: 100%;
  height: 750px;
  background: url("/static/login/loginbj.png") no-repeat center top;
}
.login-base {
  position: absolute;
  right: 0;
  top: 170px;
  width: 380px;
}
.contents{
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue